import styled, { css } from 'styled-components'
import { Spacings, Text } from '@styles'
import { Button, Label } from '@baseV2'
import { UploadButton } from '@base'

export const FormGridWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_4B};

	${Label} {
		text-transform: none;
	}
`

export const SectionRowCard = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: ${Spacings.SPACING_3B};
	width: 100%;
	background: ${({ theme }) => theme.palette.background.white};
	border: 1px solid ${({ theme }) => theme.palette.background.greyBorder};
	border-radius: ${Spacings.SPACING_5};
	padding: ${Spacings.SPACING_4B};
`

export const SectionRowTitle = styled.div`
	display: flex;
	align-items: flex-start;
	gap: 1px;
	font-size: ${Text.MEDIUM};
	font-weight: ${Text.BOLD_500};
	color: ${({ theme }) => theme.palette.text.blackGrey};
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	min-width: 0;

	${({ isRequired }) =>
		isRequired &&
		css`
			:after {
				font-size: ${Text.EXTRA_SMALL};
				content: ' (required *)';
				color: ${({ theme }) => theme.palette.text.messageRed};
				position: relative;
				top: -13%;
			}
		`}
`

export const FileActions = styled.div`
	display: flex;
	align-items: center;
	gap: ${Spacings.SPACING_3B};
	flex-shrink: 0;
`

export const IconActionButton = styled(Button).attrs({ variant: 'ghost', color: 'neutral' })`
	&& {
		background: none;
		border: 1px solid ${({ theme }) => theme.palette.background.greyBorder};
		display: flex;
		align-items: center;
		justify-content: center;
		width: ${Spacings.SPACING_11B};
		height: ${Spacings.SPACING_10B};
		padding: 0;
		color: ${({ theme, disabled }) => (disabled ? theme.palette.text.disabled : theme.palette.text.blue)};
		border-radius: ${Spacings.SPACING_5};
		min-width: unset;

		&:hover:not(:disabled) {
			background-color: transparent;
		}
	}
`

export const UploadIconButton = styled(UploadButton)`
	&& {
		background: none;
		border: 1px solid ${({ theme }) => theme.palette.background.greyBorder};
		width: ${Spacings.SPACING_11B};
		height: ${Spacings.SPACING_10B};
		min-height: unset;
		min-width: unset;
		padding: 0;
		color: ${({ theme, disabled }) => (disabled ? theme.palette.text.disabled : theme.palette.text.blue)};
		border-radius: ${Spacings.SPACING_5};

		&:hover {
			background: none;
			border-color: ${({ theme }) => theme.palette.background.greyBorder};
		}

		& > div {
			margin-right: 0;
		}
	}
`

export const PaddedWrapper = styled.div`
	margin-bottom: ${Spacings.SPACING_3B};
`

export const RadioGroupRow = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	column-gap: ${Spacings.SPACING_8B};
	min-height: ${Spacings.SPACING_10B};
`

export const RadioOption = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	column-gap: ${Spacings.SPACING_2B};
`

export const RadioOptionLabel = styled.span`
	font-size: ${Text.MEDIUM};
	color: ${({ theme }) => theme.palette.text.darkblack};
`

export const FooterActions = styled.div`
	display: flex;
	width: 100%;
	gap: ${Spacings.SPACING_3B};
	justify-content: flex-end;
`

export const ModalTitle = styled.h5`
	font-size: ${Text.LARGE};
	font-weight: ${Text.BOLD_600};
	color: ${({ theme }) => theme.palette.text.darkblack};
	padding-bottom: ${Spacings.SPACING_3B};
	border-bottom: 1px solid ${({ theme }) => theme.palette.background.greyBorder};
	margin: 0 0 ${Spacings.SPACING_4B};
`

export const ModalBody = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_3B};
	padding-bottom: 8rem;

	${Label} {
		text-transform: none;
	}
`

export const MobileFieldGroup = styled.div`
	display: flex;
	flex-direction: column;
	gap: ${Spacings.SPACING_2};
`

export const MobileRow = styled.div`
	display: flex;
	gap: ${Spacings.SPACING_2B};
	align-items: flex-end;
`

export const CountryCodeWrapper = styled.div`
	width: 5rem;
	flex-shrink: 0;
`

export const ModalActions = styled.div`
	display: flex;
	gap: ${Spacings.SPACING_2B};
	padding-top: ${Spacings.SPACING_4B};
	justify-content: flex-end;
	position: sticky;
	bottom: 0;
	background: ${({ theme }) => theme.palette.background.white};
`

export const FieldErrorText = styled.span`
	font-size: ${Text.EXTRA_SMALL};
	color: ${({ theme }) => theme.palette.text.messageRed};
`
